import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { faMicrophone } from "@fortawesome/pro-regular-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const VOX_BUTTON_POSITION = {
    left: {
        textTransform: 'rotate(180deg)',
        iconTop: '0.5rem',
        transformButtonOrigin: 'top left',
        marginLeft: '-1px',
        left: 0,
        flexDirection: 'row-reverse'

    },
    right: {
        textTransform: 'rotate(180deg)',
        iconTop: '0.5rem',
        transformButtonOrigin: 'top right',
        marginRight: '-1px',
        right: 0,
    }
};

const StyledButton = styled.button`
    position: absolute;
    top: 0;
    left: ${props => VOX_BUTTON_POSITION[props.common.voxButtonPosition].left};
    right: ${props => VOX_BUTTON_POSITION[props.common.voxButtonPosition].right};
    margin-right: ${props => VOX_BUTTON_POSITION[props.common.voxButtonPosition].marginRight};
    margin-left: ${props => VOX_BUTTON_POSITION[props.common.voxButtonPosition].marginLeft};
    ${breakpoint('xs', 'sm')`
        margin-bottom: 0;
    `};
    background: linear-gradient(180deg, ${props =>  props.common.waveformColor} 0%, ${props => props.common.buttonColor} 100%);
    border: 1px solid #FFFFFF;
    box-sizing: border-box;
    min-width: 2.3rem;
    min-height: 3rem;
    border-radius: ${(props)=> props.common.voxButtonPosition === 'right' ? '4px 0 0 4px' : '0 4px 4px 0'} ;
    transition: padding .5s ease-in-out;
    padding: 0 0.8em; 
    &:focus {
        outline: transparent;
    }
    &:hover { 
      padding: 0 1.2rem;
    }
    &.inactive {
        //top: 8rem;
    }
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: ${props => VOX_BUTTON_POSITION[props.common.voxButtonPosition].flexDirection};
    transform-origin: ${props => VOX_BUTTON_POSITION[props.common.voxButtonPosition].transformButtonOrigin};
`;

const IconOverlay = styled(FontAwesomeIcon)`
    color: white;
    font-size: 1.425rem;
    z-index: 1;
    position: absolute;
    top: ${props => VOX_BUTTON_POSITION[props.common.voxButtonPosition].iconTop};
`;

const VoxText = styled.p`
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    color: #FFFFFF;
    margin: 0;
    margin-top: 40px;
    padding: ${props => props.isSafari ? "0.65rem 0.4rem" : "0.65rem 0.1rem 0.05rem 0.1rem" };
    writing-mode: vertical-lr;
    height: max-content;
    max-height: 239px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transform: ${props => VOX_BUTTON_POSITION[props.common.voxButtonPosition].textTransform};
    width: 1rem;
`;

var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export default class RectangleButton extends Component {
    static propTypes = {
        isActive: PropTypes.bool.isRequired
    };

    state = {
        voxContent: "",
    };

    componentDidMount() {
        this.setState({voxContent: !this.props.common.showHoverText ? this.props.common.voxButtonText : ""}, this.updateHeight)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.updateHeight();
    }

    updateHeight = () => {
        const element = document.getElementById("trigger-button-rectangle");
        if (element) {
            let msg = {buttonHeight: element.offsetHeight + "px"}

            window.parent.postMessage(msg, '*');
        }
    }

    setVoxContent =() => {
        this.setState({voxContent: this.props.common.voxButtonText},this.updateHeight);
    };

    unSetVoxContent = () => {
        if (this.props.common.showHoverText) {
            this.setState({voxContent: ""},this.updateHeight)
        }
    };

    render() {
        const { isActive: active, onToggle, className, common } = this.props;
        return (
            <StyledButton
                onMouseEnter={this.setVoxContent}
                onMouseLeave={this.unSetVoxContent}
                common={common}
                className={`${className} trigger-button ${active ? 'active' : 'inactive'}`}
                onClick={onToggle}
                id={"trigger-button-rectangle"}
            >
                {this.state.voxContent && <VoxText isSafari={isSafari} common={common}>{this.state.voxContent}</VoxText>}
                <IconOverlay common={common} icon={faMicrophone}/>
            </StyledButton>
        )
    }
}
